import { Role } from '@/utils/role'

export const menu = [
  {
    icon: 'mdi-view-dashboard',
    title: 'Главная',
    routeName: 'home',
    authorize: [Role.Admin, Role.User]
  },
  {
    icon: 'mdi-desktop-tower',
    title: 'Устройства',
    routeName: 'miners',
    authorize: [Role.User]
  },
  {
    icon: 'mdi-account-multiple',
    title: 'Пользователи',
    routeName: 'subusers',
    authorize: [Role.User]
  },
  {
    icon: 'mdi-desktop-tower',
    title: 'Устройства',
    routeName: 'devices',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-account-multiple',
    title: 'Пользователи',
    routeName: 'users',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-account-cash',
    title: 'Агенты',
    routeName: 'agents',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-bitcoin',
    title: 'Пулы',
    routeName: 'pools',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-poll',
    title: 'Рейтинг',
    routeName: 'rank',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-alpha-t-box',
    title: 'телеграм',
    routeName: 'telegram',
    authorize: [Role.Admin]
  },
  // {
  //   icon: 'mdi-file-chart',
  //   title: 'Отчеты',
  //   routeName: 'report',
  //   authorize: [Role.Admin, Role.User]
  // },
  {
    icon: 'mdi-wallet',
    title: 'Кошелек',
    routeName: 'wallet',
    authorize: [Role.User]
  },
  {
    icon: 'mdi-finance',
    title: 'Финансы',
    routeName: 'finance',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-cash',
    title: 'Сделки',
    routeName: 'transaction',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-server',
    title: 'CORE-PROXY',
    routeName: 'coreproxy',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-email',
    title: 'Почта',
    routeName: 'email',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-bank-transfer-out',
    title: 'Выводы в ₽',
    routeName: 'rub-withdrawal',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-safe',
    title: 'Казначейство',
    routeName: 'treasury',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-wallet-outline',
    title: 'Корп. кошельки',
    routeName: 'corporateWallets',
    authorize: [Role.Admin]
  },
  {
    icon: 'mdi-cog',
    title: 'Настройка',
    routeName: 'settings',
    authorize: [Role.Admin, Role.User]
  }
]
